.footer {
  padding-block: var(--sp-16) var(--sp-8);
  margin-top: auto;
  border-top: 1px solid var(--border);
}
.grid {
  display: grid;
  gap: var(--sp-10) var(--sp-8);
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 11rem), 1fr));
}
.brand {
  grid-column: 1 / -1;
}
.logo {
  height: 2.25rem;
  width: auto;
}
.tagline {
  max-width: 34rem;
  margin-top: var(--sp-4);
}
.social {
  display: flex;
  gap: var(--sp-3);
  margin-top: var(--sp-4);
}
.social a {
  display: inline-grid;
  place-items: center;
  width: 2.5rem;
  height: 2.5rem;
  border: 1px solid var(--border-strong);
  border-radius: 50%;
  color: var(--text-on-dark);
}
.social a:hover {
  background: var(--surface-hover);
}
.heading {
  font-size: var(--fs-sm);
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--accent);
  margin-bottom: var(--sp-4);
}
.links {
  display: grid;
  gap: var(--sp-2);
}
.links a,
.contact a {
  color: var(--text-on-dark);
  text-decoration: none;
}
.links a:hover,
.contact a:hover {
  text-decoration: underline;
}
.contact {
  font-style: normal;
}
.legal {
  display: flex;
  flex-wrap: wrap;
  gap: var(--sp-4);
  justify-content: space-between;
  margin-top: var(--sp-12);
  padding-top: var(--sp-6);
  border-top: 1px solid var(--border);
  font-size: var(--fs-sm);
}
.legalLinks {
  display: flex;
  gap: var(--sp-5);
}
.legalLinks a {
  color: var(--text-on-dark-muted);
}
@media (min-width: 64rem) {
  .grid {
    grid-template-columns: 2fr repeat(4, 1fr) 1.4fr;
  }
  .brand {
    grid-column: auto;
  }
}
